import type { RouteObject } from 'react-router-dom';
import { YardGatePage } from 'pages/Yard-Gate';

const portariaRoute = (): RouteObject => ({
  path: 'portaria',
  element: <YardGatePage />,
});

export default portariaRoute;
